export class DocumentosUtils {
  static generarNombrePropietario = (propietario) => {
    try {
      if (propietario.identificacion.tipo === "NIT") {
        return propietario.razonSocial.replace(/\w\S*/g, (text) => {
          return text.charAt(0).toUpperCase() + text.substr(1).toLowerCase();
        });
      } else {
        const nombrePropietario = [
          propietario.primerNombre,
          propietario.segundoNombre,
          propietario.primerApellido,
          propietario.segundoApellido,
        ]
          .filter(Boolean)
          .map((s) => s.trim())
          .join(" ");
        return nombrePropietario.replace(/\w\S*/g, (text) => {
          return text.charAt(0).toUpperCase() + text.substr(1).toLowerCase();
        });
      }
    } catch (Error){
      return "Solicitante";
    } 
  };

  static generarNombreBienvenida = (solicitante) => {
    try {
      if (solicitante.identificacion.tipo === "NIT") {
        return solicitante.razonSocial;
      } else {
        return (
          solicitante.primerNombre.charAt(0).toUpperCase() +
          solicitante.primerNombre.substr(1).toLowerCase()
        );
      }
    } catch (Error){
      return "Solicitante";
    } 
  };

  static generarIdDocumento = (doc) => {
    return "DOC" + doc.id.substring(0, doc.id.indexOf("-"));
  };

  static filtrarDocsPorTipo = (docs, type) => {
    return docs
      .filter((doc) => doc.propietario.tipo === type && !doc.urlFormato)
      .sort((doc) => {
        if (doc.estado === "RECHAZADO") {
          return -1;
        }
        return 1;
      });
  };

  static filtrarDocsPorUrl = (docs) => {
    return docs.filter((doc) => doc.urlFormato);
  };

  static filtrarDocsPendientesAfiliado = (docs) => {
    return DocumentosUtils.filtrarDocsPendientesPorTipo(docs, "AFILIADO");
  };

  static filtrarDocsPendientesEmpleadores = (docs) => {
    return DocumentosUtils.filtrarDocsPendientesPorTipo(docs, "EMPLEADOR");
  };

  static filtrarDocsPendientesApoderados = (docs) => {
    return DocumentosUtils.filtrarDocsPendientesPorTipo(docs, "APODERADO");
  };

  static filtrarDocsPendientesBeneficiarios = (docs) => {
    return DocumentosUtils.filtrarDocsPendientesPorTipo(docs, "BENEFICIARIO");
  };

  static filtrarDocsPendientesReclamantes = (docs) => {
    return DocumentosUtils.filtrarDocsPendientesPorTipo(docs, "RECLAMANTE");
  };

  static filtrarDocsPendientesCuradores = (docs) => {
    return DocumentosUtils.filtrarDocsPendientesPorTipo(docs, "CURADOR");
  };

  static filtrarDocsPendientesPorTipo = (docs, tipo) => {
    return docs
      .filter(
        (doc) =>
          (doc.estado === "RECHAZADO" || doc.estado === "PENDIENTE") &&
          doc.propietario.tipo === tipo &&
          !doc.urlFormato
      )
      .map((doc) => DocumentosUtils.generarIdDocumento(doc));
  };

  static docsPendientes = (docs) => {
    return docs.filter(
      (doc) => doc.estado === "RECHAZADO" || doc.estado === "PENDIENTE"
    );
  };

  static docsPendientesFormatos = (docs) => {
    return docs
      .filter(
        (doc) =>
          (doc.estado === "RECHAZADO" || doc.estado === "PENDIENTE") &&
          doc.urlFormato
      )
      .map((doc) => DocumentosUtils.generarIdDocumento(doc));
  };

  static filtrarDocsAfiliado = (docs) => {
    return DocumentosUtils.filtrarDocsPorTipo(docs, "AFILIADO");
  };

  static filtrarDocsEmpleador = (docs) => {
    return DocumentosUtils.filtrarDocsPorTipo(docs, "EMPLEADOR");
  };

  static filtrarDocsApoderado = (docs) => {
    return DocumentosUtils.filtrarDocsPorTipo(docs, "APODERADO");
  };

  static filtrarDocsBeneficiario = (docs) => {
    return DocumentosUtils.filtrarDocsPorTipo(docs, "BENEFICIARIO");
  };

  static filtrarDocsReclamante = (docs) => {
    return DocumentosUtils.filtrarDocsPorTipo(docs, "RECLAMANTE");
  };

  static filtrarDocsCurador = (docs) => {
    return DocumentosUtils.filtrarDocsPorTipo(docs, "CURADOR");
  };

  static filtrarFormatos = (docs) => {
    return DocumentosUtils.filtrarDocsPorUrl(docs);
  };

  static obtenerIdsPropietarioPorDocs = (docs) => {
    return Array.from(
      new Set(docs.map((doc) => doc["propietario"]["identificacion"]["numero"]))
    );
  };

  static agruparDocsPorPropietario = (docs) => {
    const idsBeneficiarios = DocumentosUtils.obtenerIdsPropietarioPorDocs(docs);
    return idsBeneficiarios.map((id) => {
      const ownerDoc = docs.find(
        (doc) => doc["propietario"]["identificacion"]["numero"] === id
      );
      return {
        id: id,
        propietario: ownerDoc ? ownerDoc["propietario"] : undefined,
      };
    });
  };

  static obtenerIdCompletoDocumento = (docs, docIdShort) => {
    const docIdShortClean = docIdShort.substr(3);
    return docs.find((doc) => {
      return doc.id.startsWith(docIdShortClean);
    }).id;
  };
}
